import React, { FC, useEffect, useState, useMemo } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { usePoReportModel } from "../poReportModel";
import { IVRMPoReportDetail } from "../poReportService";
import { formatNum } from "@/utils/utils";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import { useDictModel } from "@/views/base/dict/dictModel";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";
import YhTootip from "@/components/YhTootip";

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys,
        setHistoryVisible,
        setHistoryRow,
    } = usePoReportModel();
    const { getTreeNodeName } = useDictModel();
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();

    const onHistoryModel = (record: IVRMPoReportDetail) => {
        setHistoryVisible(true)
        setHistoryRow(record)
    }

    useEffect(() => {
        loadData();
    }, [])

    const defaultColumns: ColumnsType<IVRMPoReportDetail> = [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            align: "center",
            render: (t, r, i) => i + 1
        }, {
            title: '供应商名称',
            width: 160,
            dataIndex: 'supplierName',
            render: text => <Tooltip placement="topLeft" title={text} arrowPointAtCenter><p className="ellipsis">{text}</p></Tooltip>
        }, {
            title: '供应商类型',
            width: 150,
            dataIndex: 'supplierTypeName',
        }, {
            title: '单据编号',
            width: 180,
            dataIndex: 'code',

        }, {
            title: '单据类型',
            width: 100,
            dataIndex: 'tradeTypeName',
        }, {
            title: '单据状态',
            width: 100,
            dataIndex: 'status',
            render: (text) => getTreeNodeName(text)
        }, {
            title: '采购类型',
            width: 120,
            dataIndex: 'orderTypeName',
        }, {
            title: '结算类型',
            width: 120,
            dataIndex: 'payTypeName',
        }, {
            title: '商品编号',
            width: 200,
            dataIndex: 'materialCode',
            render: (text: any, record: any, index: number) => <Tooltip placement="topLeft" title={text}><p className="ellipsis click-span" onClick={(e) => { e.stopPropagation(); onHistoryModel(record) }}>{text}</p></Tooltip>,
        }, {
            title: '商品名称',
            width: 200,
            dataIndex: 'materialName',
            render: text => <Tooltip placement="topLeft" title={text} arrowPointAtCenter><p className="ellipsis">{text}</p></Tooltip>
        }, {
            title: '商品类型',
            width: 160,
            dataIndex: 'typeName',
        }, {
            title: '配件采购频次',
            width: 110,
            dataIndex: 'purchaseCount',
        }, {
            title: '配件采退频次',
            width: 110,
            dataIndex: 'preturnCount',
        }, {
            title: '采购价格',
            width: 160,
            dataIndex: 'price',
            render: text => '￥' + Math.abs(text ?? 0)
            // render: (text) => `￥${text}`

        }, {
            title: '采购数量',
            width: 160,
            dataIndex: 'num',
            // render: (text: number, record) => record.tradeTypeCode === DictCodeEnmu.TRADE_TYPE_PRO ? `-${text}` : `${text}`
        }, {
            title: '采购金额',
            width: 160,
            dataIndex: 'amount',
            // render: (text: number, record) => record.tradeTypeCode === DictCodeEnmu.TRADE_TYPE_PRO ? `-￥${text}` : `￥${text}`
        }, {
            title: '制单人',
            width: 160,
            dataIndex: 'createUser',
        }, {
            title: '制单时间',
            width: 160,
            dataIndex: 'createTime',
        }, {
            title: '结算时间',
            width: 160,
            dataIndex: 'settleTime',
        }, {
            title: '从属站点',
            width: 160,
            dataIndex: 'shopName',
            // }, {
            //     title: '结算日期',
            //     width: 160,
            //     dataIndex: 'settleTime',
        }, {
            title: '备注',
            width: 200,
            dataIndex: 'note',
        },
        {
            title: '所属站点',
            width: 250,
            fixed: "right",
            dataIndex: 'shopName',
            render: (text: any) => <YhTootip text={text} style={{ width: 250 }} />,
        }
    ];

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "purchaseDetailStatic", "roleCodes": roles };
        return getRoleColumns("purchaseDetailStatic", "主单", defaultColumns, params);
    }, [roles, dataSource]);
    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            bordered
            rowKey={record => record.id}
            // rowSelection={{
            //     selectedRowKeys: selectedRowKeys, //记录选中
            //     //全部选中时  (存string[])
            //     onSelectAll: (selected, selectedRows, changeRows) => {
            //         let changeRowId = changeRows.map(item => item.id);
            //         selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
            //             : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
            //     },
            //     onSelect: (record) => onRow(record.id),
            // }}
            columns={roleColumns}
            dataSource={dataSource}
            pagination={{
                showSizeChanger: true,
                ...pgCfg,
                defaultPageSize: 25,
                pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                position: ["bottomRight"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            // onRow={record => ({
            //     onClick: () => onRow(record.id)
            // })}
            scroll={{ x: 'max-content', y: "calc(100vh - 340px)" }}
        />
    )
}